export const ALL_PERMISSION = [
  {
    name: 'Dashboard',
    value: 'dashboard',
    options: [
      {
        name: 'View Dashboard',
        value: 'view_dashboard',
        checked: false
      }
    ]
  },
  {
    name: 'Products',
    value: 'products',
    options: [
      {
        name: 'View Products',
        value: 'view_products',
        checked: false
      },
      {
        name: 'Add Products',
        value: 'add_products',
        checked: false
      },
      {
        name: 'Edit Products',
        value: 'edit_products',
        checked: false
      },
      {
        name: 'Product replicate',
        value: 'product-replicate',
        checked: false
      },
      {
        name: 'Product Mapping',
        value: 'product_invoice',
        checked: false
      },
      {
        name: 'Product Serial Stocks',
        value: 'product_serial_stocks',
        checked: false
      },
      {
        name: 'Inactive Serial Store',
        value: 'inactive_serial_store',
        checked: false
      },
      {
        name: 'Delete Products',
        value: 'delete_products',
        checked: false
      }
    ]
  },
  {
    name: 'Menu',
    value: 'menu',
    options: [
      {
        name: 'View Menu',
        value: 'view_menu',
        checked: false
      },
      {
        name: 'Add Menu',
        value: 'add_menu',
        checked: false
      },
      {
        name: 'Edit Menu',
        value: 'edit_menu',
        checked: false
      },
      {
        name: 'Delete Menu',
        value: 'delete_menu',
        checked: false
      }
    ]
  },
  {
    name: 'Unit',
    value: 'unit',
    options: [
      {
        name: 'View Unit',
        value: 'view_unit',
        checked: false
      },
      {
        name: 'Add Unit',
        value: 'add_unit',
        checked: false
      },
      {
        name: 'Edit Unit',
        value: 'edit_unit',
        checked: false
      },
      {
        name: 'Delete Unit',
        value: 'delete_unit',
        checked: false
      }
    ]
  },
  {
    name: 'Category',
    value: 'category',
    options: [
      {
        name: 'View Category',
        value: 'view_category',
        checked: false
      },
      {
        name: 'Add Category',
        value: 'add_category',
        checked: false
      },
      {
        name: 'Edit Category',
        value: 'edit_category',
        checked: false
      },
      {
        name: 'Delete Category',
        value: 'delete_category',
        checked: false
      }
    ]
  },
  {
    name: 'Cash Register',
    value: 'cash_register',
    options: [
      {
        name: 'View Cash Register',
        value: 'view_cash_register',
        checked: false
      },
      {
        name: 'Open Cash Register',
        value: 'open_cash_register',
        checked: false
      },
      {
        name: 'Close Cash Register',
        value: 'close_cash_register',
        checked: false
      },
      {
        name: 'View Cash Register Audit',
        value: 'view_cash_register_audit',
        checked: false
      }
    ]
  },
  {
    name: 'Direct Sales',
    value: 'sales',
    options: [
      {
        name: 'View Sales',
        value: 'view_sales',
        checked: false
      },
      {
        name: 'Add Sales',
        value: 'add_sales',
        checked: false
      },
      {
        name: 'Distributors Sales',
        value: 'distributors_sales',
        checked: false
      },
      {
        name: 'Used Stocks',
        value: 'used-stock',
        checked: false
      },
      {
        name: 'Edit Sales',
        value: 'edit_sales',
        checked: false
      },
      {
        name: 'Delete Sales',
        value: 'delete_sales',
        checked: false
      }
    ]
  },
  {
    name: 'Customer Direct Sales',
    value: 'customer_sales',
    options: [
      {
        name: 'Open Table',
        value: 'open_table',
        checked: false
      },
      {
        name: 'Close Table',
        value: 'close_table',
        checked: false
      },
      {
        name: 'Place Order',
        value: 'place_order',
        checked: false
      },
      {
        name: 'Take Payment',
        value: 'take_payment',
        checked: false
      }
    ]
  },
  {
    name: 'Purchases',
    value: 'purchases',
    options: [
      {
        name: 'View Purchases',
        value: 'view_purchases',
        checked: false
      },
      {
        name: 'Add Purchases',
        value: 'add_purchases',
        checked: false
      },
      {
        name: 'Edit Purchases',
        value: 'edit_purchases',
        checked: false
      },
      {
        name: 'Purchase Action',
        value: 'purchase_action',
        checked: false
      },
      {
        name: 'Payment Action',
        value: 'payment_action',
        checked: false
      },
      // {
      //   name: 'eSim Upload',
      //   value: 'esim_upload_lists',
      //   checked: false
      // },
      // {
      //   name: 'preSim Upload',
      //   value: 'pre_sim_upload_lists',
      //   checked: false
      // }
    ]
  },
  {
    name: 'Uploads',
    value: 'uploads',
    options: [
      {
        name: 'eSim Upload',
        value: 'esim_upload_lists',
        checked: false
      },
      {
        name: 'preSim Upload',
        value: 'pre_sim_upload_lists',
        checked: false
      },
      {
        name: 'lookup puk lists',
        value: 'lookup_puk_lists',
        checked: false
      },
      {
        name: 'Pre-Esim Upload',
        value: 'pre_esim_upload_lists',
        checked: false
      },
      {
        name: 'Pre-Mifi-Router Upload',
        value: 'pre_assign_mifi_router',
        checked: false
      }
    ]
  },
  {
    name: 'Inventory',
    value: 'inventory',
    options: [
      {
        name: 'View Available Stock',
        value: 'view_available_stock',
        checked: false
      },
      {
        name: 'View Serial Stock',
        value: 'view_serial_stock',
        checked: false
      },
    ]
  },
  {
    name: 'Partners Menu',
    value: 'partner_settings',
    options: [
      {
        name: 'Partners',
        value: 'create_distributor_partner',
        checked: false
      },
      {
        name: 'Distributors Agents',
        value: 'create_distributor_agent',
        checked: false
      },
      {
        name: 'Sub Stores',
        value: 'partner_business_locations',
        checked: false
      },
      {
        name: 'Agents',
        value: 'partner_user_lists',
        checked: false
      },
      {
        name: 'Partner Agents',
        value: 'partner_agent_lists',
        checked: false
      },
      {
        name: 'Super-Agents',
        value: 'super_agents',
        checked: true
      },
      {
        name: 'FSR',
        value: 'fsr',
        checked: true
      },
      // {
      //   name: 'Tier1 Partners',
      //   value: 'tier1_partners',
      //   checked: false
      // },
      {
        name: 'Wallets',
        value: 'wallets',
        checked: false
      },
      {
        name: 'View Stocks',
        value: 'view_stocks',
        checked: false
      },
      {
        name: 'Transaction Logs',
        value: 'transaction-logs',
        checked: false
      },
      // {
      //   name: 'Sales Report',
      //   value: 'sales_report',
      //   checked: false
      // },
    ]
  },
  {
    name: 'Stock Transfer',
    value: 'stock_transfer',
    options: [
      {
        name: 'View Stock Transfer',
        value: 'view_stock_transfer',
        checked: false
      },
      {
        name: 'Add Stock Transfer',
        value: 'add_stock_transfer',
        checked: false
      },
      {
        name: 'Edit Stock Transfer',
        value: 'edit_stock_transfer',
        checked: false
      },
      {
        name: 'Delete Stock Transfer',
        value: 'delete_stock_transfer',
        checked: false
      },
      {
        name: 'Transfer Action',
        value: 'transfer_action',
        checked: false
      }
    ]
  },
  {
    name: 'Stock Adjustment',
    value: 'stock_adjustment',
    options: [
      {
        name: 'View Stock Adjustment',
        value: 'view_stock_adjustment',
        checked: false
      },
      {
        name: 'Add Stock Adjustment',
        value: 'add_stock_adjustment',
        checked: false
      },
      {
        name: 'Edit Stock Adjustment',
        value: 'edit_stock_adjustment',
        checked: false
      },
      {
        name: 'Delete Stock Adjustment',
        value: 'delete_stock_adjustment',
        checked: false
      }
    ]
  },
  {
    name: 'Stock Audit',
    value: 'stock_audit',
    options: [
      {
        name: 'View Stock Audit',
        value: 'view_stock_audit',
        checked: false
      },
      {
        name: 'Add Stock Audit',
        value: 'add_stock_audit',
        checked: false
      },
      {
        name: 'Edit Stock Audit',
        value: 'edit_stock_audit',
        checked: false
      },
      {
        name: 'Delete Stock Audit',
        value: 'delete_stock_audit',
        checked: false
      }
    ]
  },
  {
    name: 'Stock Withdrawer',
    value: 'stock_withdrawer',
    options: [
      {
        name: 'Partner Stock Withdrawer',
        value: 'partner_stock_withdrawer',
        checked: false
      },
      {
        name: 'View Stock Withdrawer',
        value: 'view_stock_withdrawer',
        checked: false
      }
    ]
  },
  {
    name: 'Fulfilments',
    value: 'fulfilments',
    options: [
      {
        name: 'Fulfilment List',
        value: 'fulfilment_lists',
        checked: false
      },
      {
        name: 'Stock Request',
        value: 'stock_request',
        checked: false
      },
      {
        name: 'Digital Stock Request',
        value: 'digital_stock_request',
        checked: false
      }
    ]
  },
  {
    name: 'Reports',
    value: 'reports',
    options: [
      {
        name: 'Products Report',
        value: 'products_report',
        checked: false
      },
      {
        name: 'Partner Reports',
        value: 'partner_reports',
        checked: false
      },
      {
        name: 'Locations Report',
        value: 'locations_report',
        checked: false
      },
      {
        name: 'Customer Sales Report',
        value: 'customer_sales_report',
        checked: false
      },
      {
        name: 'Direct Sales Report',
        value: 'direct_sales_report',
        checked: false
      },
      {
        name: 'Purchase Report',
        value: 'purchase_report',
        checked: false
      },
      {
        name: 'Management Report',
        value: 'management_report',
        checked: false
      },
      {
        name: 'Marketing',
        value: 'marketing_report',
        checked: false
      },
      {
        name: 'Accounting',
        value: 'accounting_report',
        checked: false
      },
      {
        name: 'Activities',
        value: 'partners_activities_reports',
        checked: false
      },
      {
        name: 'Regulatory',
        value: 'regulatory_report',
        checked: false
      },
      {
        name: 'Vending',
        value: 'vending',
        checked: false
      }
    ]
  },
  {
    name: 'Account Section',
    value: 'accounts_section',
    options: [
      {
        name: 'Account Admin Section',
        value: 'accounts_admin_section',
        checked: false
      }
    ]
  },
  {
    name: 'Accounting',
    value: 'accounting',
    options: [
      {
        name: 'Sell Commission',
        value: 'sell_commissions',
        checked: false
      },
    ]
  },
  {
    name: 'Payments',
    value: 'payments',
    options: [
      {
        name: 'Agents LLP',
        value: 'agents_llp',
        checked: false
      },
      {
        name: 'Agents Target',
        value: 'agents_target',
        checked: false
      }
    ]
  },
  // {
  //   name: 'Admin Section',
  //   value: 'admin_section',
  //   options: [
  //     {
  //       name: 'Access Admin Section',
  //       value: 'access_admin_section',
  //       checked: false
  //     },
  //     {
  //       name: 'Business Locations',
  //       value: 'business_locations',
  //       checked: false
  //     },
  //     {
  //       name: 'User Lists',
  //       value: 'user_lists',
  //       checked: false
  //     },
  //     {
  //       name: 'Partner Lists',
  //       value: 'partner_lists',
  //       checked: false
  //     },
  //     {
  //       name: 'Business Customers',
  //       value: 'business_customers',
  //       checked: false
  //     },
  //     {
  //       name: 'Images',
  //       value: 'product-image-upload',
  //       checked: false
  //     },
  //     {
  //       name: 'Roles',
  //       value: 'roles',
  //       checked: false
  //     },
  //     {
  //       name: 'Dispatchs',
  //       value: 'dispatch',
  //       checked: false
  //     },
  //     {
  //       name: 'Manage Data Bundle',
  //       value: 'manage_data_bundles',
  //       checked: false
  //     },
  //     {
  //       name: 'manage-plans-matrix',
  //       value: 'manage_plans_matrix',
  //       checked: false
  //     }
  //   ]
  // },
  {
    name: 'Settings',
    value: 'settings',
      options: [
        // {
        //   name: 'Access Admin Section',
        //   value: 'access_admin_section',
        //   checked: false
        // },
        {
          name: 'Business Locations',
          value: 'business_locations',
          checked: false
        },
        {
          name: 'User Lists',
          value: 'user_lists',
          checked: false
        },
        {
          name: 'Partner Lists',
          value: 'partner_lists',
          checked: false
        },
        {
          name: 'Allocate Distributor Partners',
          value: 'allocate_distributor_partners',
          checked: false
        },
        {
          name: 'Business Customers',
          value: 'business_customers',
          checked: false
        },
        {
          name: 'Images',
          value: 'product-image-upload',
          checked: false
        },
        {
          name: 'Roles',
          value: 'roles',
          checked: false
        },
        {
          name: 'Dispatchs',
          value: 'dispatch',
          checked: false
        },
        {
          name: 'Manage Data Bundle',
          value: 'manage_data_bundles',
          checked: false
        },
        {
          name: 'manage-plans-matrix',
          value: 'manage_plans_matrix',
          checked: false
        }
      ]
  },
  {
    name: 'Roles',
    value: 'roles',
    options: [
      {
        name: 'View Roles',
        value: 'view_roles',
        checked: false
      },
      {
        name: 'Add Roles',
        value: 'add_roles',
        checked: false
      },
      {
        name: 'Edit Roles',
        value: 'edit_roles',
        checked: false
      },
      {
        name: 'Delete Roles',
        value: 'delete_roles',
        checked: false
      }
    ]
  },
  {
    name: 'Contacts',
    value: 'contacts',
    options: [
      {
        name: 'View Contacts',
        value: 'view_contacts',
        checked: false
      },
      {
        name: 'Add Contacts',
        value: 'add_contacts',
        checked: false
      },
      {
        name: 'Edit Contacts',
        value: 'edit_contacts',
        checked: false
      },
      {
        name: 'Delete Contacts',
        value: 'delete_contacts',
        checked: false
      }
    ]
  }
];
